import axios from 'axios';
import moment from 'moment';
import store from '../..';
import * as actionTypes from './callCheckLoadsActionTypes';

const buildUrl = (resource, method = '', query) => (query ? `/api/${resource}/${method}?id=${query}` : `/api/${resource}/${method}`);

const axiosConfig = () => ({
  headers: {
    Authorization: 'Bearer ' + store.getState().auth.userToken,
  },
});

export const load = (resource, pageName, filterOptions, pagination, loadingType) => dispatch => {
  const {
    loadType = null,
    state = null,
    region = null,
    carrier = null,
    mcNumber = null,
    dotNumber = null,
    searchText = null,
    pickAppointment = null,
    dropAppointment = null,
  } = filterOptions || [];

  const { page = 1, pageSize = 4 } = pagination || [];

  if (loadingType !== 'withoutLoading') {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_LOADING) });
  }

  const payload = {
    page: page || 1,
    pageSize: pageSize || 4,
    loadType: loadType,
    regionId: region ? Number(region.value) : null,
    stateId: state ? Number(state.value) : null,
    carrierId: carrier ? Number(carrier.value) : null,
    mcNumber: mcNumber ? Number(mcNumber) : null,
    dotNumber: dotNumber ? Number(dotNumber) : null,
    searchText: searchText,
    pickAppointment: pickAppointment ? pickAppointment : null,
    dropAppointment: dropAppointment ? dropAppointment : null,
  };

  axios
    .post(buildUrl('callCheck', `get${pageName}`), payload, axiosConfig())
    .then(response =>
      dispatch({
        type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS),
        data: {
          response,
          pageName,
        },
      }),
    )
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setHeaderWidth = (resource, ind, width) => ({
  type: actionTypes.getActionType(resource, actionTypes.SET_HEADER_WIDTH_CALL_CHECK_LOADS),
  data: { ind, width },
});

export const setHeaderWidthLoadDetails = (resource, ind, width, type) => ({
  type: actionTypes.getActionType(resource, actionTypes.SET_HEADER_WIDTH_CALL_CHECK_LOADS_DETAILS),
  data: { ind, width, type },
});

export const setLoadStatusData = (resource, pageName, value, rowState) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_LOADS_STATUS_DATA),
    data: {
      value,
      rowState,
    },
  });

  const payload = {
    loadId: rowState.id,
    loadStopType: rowState.type === 'dropLoad' ? 2 : 1,
    loadStopStatus: value,
  };

  axios
    .put(buildUrl('callcheck', 'updateloadstopstatus'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        const payload = {
          page: 1,
          pageSize: 4,
          loadType: null,
          regionId: null,
          stateId: null,
          carrierId: null,
          mcNumber: null,
          dotNumber: null,
          searchText: null,
          pickAppointment: null,
          dropAppointment: null,
        };
        dispatch(errorAction(`callCheck/get${pageName}`, payload, true, response.data.message));
        console.error(response.data.message);
      }
      dispatch(getLoadDetails(resource, rowState.id, 'withoutLoading'));
    })
    .catch(err => {
      dispatch(errorAction(`callCheck/get${pageName}`, payload, true));
      console.error(err);
      console.log(err.response);
    });
};

export const setStopStatusData = (resource, pageName, value, rowState) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOPS_STATUS_DATA),
    data: {
      value,
      rowState,
    },
  });

  const payload = {
    loadId: rowState.loadId,
    loadStopType: rowState.loadType === 'pickLoad' ? 1 : 2,
    orderStopStatus: value,
    ...(!rowState.stopData?.subOrderIds?.length &&
      rowState.stopData.orderIds.length &&
      rowState.stopData.orderIds[0] && { orderId: rowState.stopData.orderIds[0] }),
    ...(!rowState.stopData?.orderIds?.length &&
      rowState.stopData.subOrderIds.length &&
      rowState.stopData.subOrderIds[0] && { subOrderId: rowState.stopData.subOrderIds[0] }),
  };

  axios
    .put(buildUrl('callcheck', 'updatestopstatus'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        dispatch(reloadAfterUpdate(resource, pageName));
        console.error(response.data.message);
      }
      dispatch(getLoadDetails(resource, rowState.loadId, 'withoutLoading'));
    })
    .catch(err => {
      dispatch(errorAction(`callCheck/get${pageName}`, payload, true));
      console.error(err);
      console.log(err.response);
    });
};

export const setStopDate = (resource, pageName, value, rowState, header) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOPS_DATE),
    data: {
      value,
      rowState,
      header,
    },
  });

  const date = new Date(value);
  const formattedDate = value ? moment(date)
    .seconds(0)
    .milliseconds(0)
    .format("YYYY-MM-DDTHH:mm:ss") : null;

  const formatDate = date => {
    return date ? moment(date).seconds(0).milliseconds(0).format("YYYY-MM-DDTHH:mm:ss") : null;
  }

  const payload = {
    loadId: rowState.loadId,
    loadStopType: rowState.loadType === 'pickLoad' ? 1 : 2,
    puDate: rowState.stopData.puDate,
    ...(rowState.loadType === 'pickLoad' && header.key === 'checkIn' && { pickIn: formattedDate }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'checkIn'  && { pickOut: formatDate(rowState.stopData.pickOut) }),

    ...(rowState.loadType === 'pickLoad' && header.key === 'checkOut' && { pickIn: formatDate(rowState.stopData.pickIn) }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'checkOut' && { pickOut: formattedDate }),

    ...(rowState.loadType === 'dropLoad' && header.key === 'checkIn' && { dropIn: formattedDate }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'checkIn' && { dropOut: formatDate(rowState.stopData.dropOut) }),

    ...(rowState.loadType === 'dropLoad' && header.key === 'checkOut' && { dropIn: formatDate(rowState.stopData.dropIn) }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'checkOut' && { dropOut: formattedDate }),

    ...(!rowState.stopData?.subOrderIds?.length && rowState.stopData?.orderIds?.[0] && { orderId: rowState.stopData.orderIds[0] }),
    ...(!rowState.stopData?.orderIds?.length && rowState.stopData?.subOrderIds?.[0] && { subOrderId: rowState.stopData.subOrderIds[0] }),
    
    ...(rowState.stopData?.stopOrders && rowState.stopData?.stopOrders[0] && rowState.stopData.stopOrders[0]?.orderId && { orderId: rowState.stopData.stopOrders[0].orderId }),
    ...(rowState.stopData?.stopOrders && rowState.stopData?.stopOrders[0] && rowState.stopData.stopOrders[0]?.subOrderId && { subOrderId: rowState.stopData.stopOrders[0].subOrderId }),
  };

  axios
    .put(buildUrl('callcheck', 'updateloadstop'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        const payload = {
          page: 1,
          pageSize: 4,
          loadType: null,
          regionId: null,
          stateId: null,
          carrierId: null,
          mcNumber: null,
          dotNumber: null,
          searchText: null,
          pickAppointment: null,
          dropAppointment: null,
        };
        dispatch(errorAction(`callCheck/get${pageName}`, payload, true, response.data.message));
        dispatch(reloadAfterUpdate(resource, pageName, 'withLoading'))
        console.error(response.data.message);
      }
      dispatch(reloadAfterUpdate(resource, pageName));
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setItemDisplayState = (resource, rowState, header, enable) => ({
  type: actionTypes.getActionType(resource, actionTypes.SET_DISPLAY_STATE_CALL_CHECK_LOADS),
  data: {
    rowState,
    header,
    enable,
  },
});

export const filterCallCheckLoads = (resource, filterType, option) => ({
  type: actionTypes.getActionType(resource, actionTypes.FILTER_CALL_CHECK_LOADS),
  data: {
    filterType,
    option,
  },
});

export const callCheckLoadsPagination = (resource, filterType, option) => ({
  type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_PAGINATION),
  data: {
    filterType,
    option,
  },
});

export const getLoadNotes = (resource, rowState, loadType) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_LOAD_NOTES_LOADING) });
  
  let loadId = '';
  if (rowState.type === 'stop') {
    loadId = rowState.loadId;
  } else if (rowState.type === 'load') {
    loadId = rowState.id;
  }
  const filterData = {
    params: {
      loadId: loadId,
      stopType: loadType === 'drop' ? 2 : 1,
    },
    headers: axiosConfig().headers,
  };

  axios
    .get(buildUrl('load', 'getloadcomments'), filterData, axiosConfig())
    .then(response => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_LOAD_NOTES), data: response }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_LOAD_NOTES_ERROR) });
    });
};

export const getStopNotes = (resource, stop) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_STOP_NOTES_LOADING) });

  const payload = {
    loadId: stop.loadId,
    loadStopType: stop.loadType === 'dropLoad' ? 2 : 1,
    ...(!stop.stopData?.subOrderIds?.length && stop.stopData.orderIds && stop.stopData.orderIds[0] && { orderId: stop.stopData.orderIds[0] }),
    ...(stop.stopData?.subOrderIds?.length && stop.stopData.orderIds && stop.stopData.subOrderIds[0] && { subOrderId: stop.stopData.subOrderIds[0] }),
    
    ...(stop.stopData?.stopOrders && stop.stopData?.stopOrders[0] && stop.stopData.stopOrders[0]?.orderId && { orderId: stop.stopData.stopOrders[0].orderId }),
    ...(stop.stopData?.stopOrders && stop.stopData?.stopOrders[0] && stop.stopData.stopOrders[0]?.subOrderId && { subOrderId: stop.stopData.stopOrders[0].subOrderId }),
  };

  axios
    .post(buildUrl('callCheck', 'getStopNotes'), payload, axiosConfig())
    .then(response => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_STOP_NOTES), data: response }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_STOP_NOTES_ERROR) });
    });
};

export const getOrderNotes = (resource, order) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_ORDER_NOTES_LOADING) });

  const filterData = {
    params: {
      orderId: order.orderId,
      stopType: load.type === 'dropLoad' ? 2 : 1,
    },
    headers: axiosConfig().headers,
  };

  axios
    .get(buildUrl('order', 'getordercomments'), filterData, axiosConfig())
    .then(response => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_ORDER_NOTES), data: response }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_ORDER_NOTES_ERROR) });
    });
};

export const setOrderNote = (resource, rowState, note, loadId) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_ORDER_NOTE_LOADING) });

  const payload = {
    id: rowState.orderId,
    comment: note,
  };

  axios
    .post(buildUrl('order', 'createordercomment'), payload, axiosConfig())
    .then(response => {
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_ORDER_NOTE), 
        data: {
          response: response, 
          orderId: rowState.orderId,
        }
      })
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setLoadNote = (resource, rowState, note, loadType) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_LOAD_NOTE_LOADING) });
  
  let id = '';
  if (rowState.type === 'stop') {
    id = rowState.loadId;
  } else if (rowState.type === 'load') {
    id = rowState.id;
  }
  const payload = {
    id: id,
    comment: note,
    loadStopType: loadType === 'drop' ? 2 : 1,
  };

  axios
    .post(buildUrl('load', 'createloadcomment'), payload, axiosConfig())
    .then(response => {
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_LOAD_NOTE), 
        data: {
          note: response.data,
          loadType,
        }
      })
    })      
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setStopNote = (resource, stop, note) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOP_NOTE_LOADING) });

  const payload = {
    note: note,
    loadId: stop.loadId,
    loadStopType: stop.loadType === 'dropLoad' ? 2 : 1,
    puDate: stop.stopData.puDate,
    ...(!stop.stopData?.subOrderIds?.length && stop.stopData.orderIds && stop.stopData.orderIds[0] && { orderId: stop.stopData.orderIds[0] }),
    ...(!stop.stopData?.orderIds?.length && stop.stopData.subOrderIds && stop.stopData.subOrderIds[0] && { subOrderId: stop.stopData.subOrderIds[0] }),
  
  ...(stop.stopData?.stopOrders && stop.stopData?.stopOrders[0] && stop.stopData.stopOrders[0]?.orderId && { orderId: stop.stopData.stopOrders[0].orderId }),
  ...(stop.stopData?.stopOrders && stop.stopData?.stopOrders[0] && stop.stopData.stopOrders[0]?.subOrderId && { subOrderId: stop.stopData.stopOrders[0].subOrderId }),

  };

  axios
    .post(buildUrl('callCheck', 'createstopnotes'), payload, axiosConfig())
    .then(response => {
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOP_NOTE), data: response })
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setEmptyAllNotes = (resource) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_ALL_NOTES_EMPTY)});
};

export const setCurrentUser = (resource, rowState, userFirstName) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_CURRENT_USER),
    data: {
      value: userFirstName,
      rowState,
    },
  });

  axios
    .put(buildUrl('callcheck', `maketoworking?loadId=${rowState.id}`), '', axiosConfig())
    .then(response => {
      // dispatch(reloadAfterUpdate());
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setLoadToDeliver = (resource, loadId, page) => dispatch => {
  axios
    .put(buildUrl('callcheck', `deliverload?loadId=${loadId}`), '', axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
      } else {
        dispatch(reloadAfterUpdate(resource, page));
      }
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const getLoadDetails = (resource, loadId, withoutLoading) => dispatch => {
  withoutLoading !== 'withoutLoading' && dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOAD_DETAILS_LOADING) });
  
  axios
    .get(buildUrl('callCheck', `getcheckcalllloaddetails?loadId=${loadId}`), axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        // dispatch(reloadAfterUpdate(resource, page)); TODO open later
      } else {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOAD_DETAILS), data: response });
      }
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOAD_DETAILS_ERROR) });
    });
};

export const setLoadDetailsStatusData = (resource, pageName, value, rowState, type, loadId) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_LOADS_DETAILS),
    data: {
      value,
      rowState,
      type,
    },
  });

  const payload = {
    loadId: loadId,
    loadStopType: type === 'pick' ? 1 : 2,
    loadStopStatus: value,
  };

  axios
    .put(buildUrl('callcheck', 'updateloadstopstatus'), payload, axiosConfig())
    .then(response => {
      const payload = {
          page: 1,
          pageSize: 4,
          loadType: null,
          regionId: null,
          stateId: null,
          carrierId: null,
          mcNumber: null,
          dotNumber: null,
          searchText: null,
          pickAppointment: null,
          dropAppointment: null,
      };
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        dispatch(errorAction(`callCheck/get${pageName}`, payload, true, response.data.message));
        console.error(response.data.message);
      }
      dispatch(reloadAfterUpdate(resource, pageName));
    })
    .catch(err => {
      dispatch(errorAction(`callCheck/get${pageName}`, payload, true));
      console.error(err);
      console.log(err.response);
    });
};

export const setStopDetailsStatusData = (resource, pageName, value, rowState) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOPS_DETAILS_STATUS_DATA),
    data: {
      value,
      rowState,
    },
  });

  const payload = {
    loadId: rowState.loadId,
    loadStopType: rowState.loadType === 'pickLoad' ? 1 : 2,
    orderStopStatus: value,
    ...(!rowState.stopData?.stopOrders[0].subOrderId &&
      rowState.stopData.stopOrders[0].orderId && { orderId: rowState.stopData.stopOrders[0].orderId }),
    ...(!rowState.stopData?.stopOrders[0].orderId &&
      rowState.stopData.stopOrders[0].subOrderId && { subOrderId: rowState.stopData.stopOrders[0].subOrderId }),
  };

  axios
    .put(buildUrl('callcheck', 'updatestopstatus'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        console.error(response.data.message);
      }
      dispatch(getLoadDetails(resource, rowState.loadId, 'withoutLoading'));
      dispatch(reloadAfterUpdate(resource, pageName));
    })
    .catch(err => {
      dispatch(errorAction(`callCheck/get${pageName}`, payload, true));
      console.error(err);
      console.log(err.response);
    });
};

export const resetError = resource => ({ type: actionTypes.getActionType(resource, actionTypes.RESET_ERROR) });

const errorAction = (resource, payload, reload, message) => dispatch => {
  if (reload) {
    axios
      .post(buildUrl(resource), payload, axiosConfig())
      .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.RELOAD_ON_ERROR_CALL_CHECK_LOADS), data: responce }))
      .catch(err => {
        console.error(err);
        console.log(err.response);
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
      });
  }
};

const reloadAfterUpdate = (resource, pageName, loadingType) => dispatch => {
  if (loadingType === 'withLoading') {
    dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS_LOADING) });
  }

  const payload = {
    page: 1,
    pageSize: 4,
    loadType: null,
    regionId: null,
    stateId: null,
    carrierId: null,
    mcNumber: null,
    dotNumber: null,
    searchText: null,
    pickAppointment: null,
    dropAppointment: null,
  };
  axios
    .post(buildUrl(`callCheck/get${pageName}`), payload, axiosConfig())
    .then(response =>
      dispatch({
        type: actionTypes.getActionType(resource, actionTypes.GET_CALL_CHECK_LOADS),
        data: {
          response,
          pageName,
        },
      }),
    )
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setStopDateDetails = (resource, pageName, value, rowState, header) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS),
    data: {
      value,
      rowState,
      header,
    },
  });

  const date = new Date(value);
  const formattedDate = value ? moment(date)
    .seconds(0)
    .milliseconds(0)
    .format("YYYY-MM-DDTHH:mm:ss") : null;

  const formatDate = date => {
    return date ? moment(date).seconds(0).milliseconds(0).format("YYYY-MM-DDTHH:mm:ss") : null;
  }

  const payload = {
    loadId: rowState.loadId,
    loadStopType: rowState.loadType === 'pickLoad' ? 1 : 2,
    ...(rowState.loadType === 'pickLoad' && header.key === 'pickIn' && { pickIn: formattedDate }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'pickIn' && { pickOut: formatDate(rowState.stopData.pickOut) }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'pickIn' && { puDate: formatDate(rowState.stopData.stopOrders[0].puDate) }),

    ...(rowState.loadType === 'pickLoad' && header.key === 'pickOut' && { pickIn: formatDate(rowState.stopData.pickIn) }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'pickOut' && { pickOut: formattedDate }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'pickOut' && { puDate: formatDate(rowState.stopData.stopOrders[0].puDate) }),

    ...(rowState.loadType === 'dropLoad' && header.key === 'dropIn' && { dropIn: formattedDate }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'dropIn' && { dropOut:  formatDate(rowState.stopData.dropOut) }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'dropIn' && { puDate: formatDate(rowState.stopData.stopOrders[0].puDate) }),

    ...(rowState.loadType === 'dropLoad' && header.key === 'dropOut'  && { dropIn:  formatDate(rowState.stopData.dropIn) }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'dropOut' && { dropOut: formattedDate }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'dropOut' && { puDate: formatDate(rowState.stopData.stopOrders[0].puDate) }),

    ...(header.key === 'puDate' && { puDate: formattedDate }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'puDate' && { pickOut: formatDate(rowState.stopData.pickOut) }),
    ...(rowState.loadType === 'pickLoad' && header.key === 'puDate' && { pickIn: formatDate(rowState.stopData.pickIn) }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'puDate' && { dropOut:  formatDate(rowState.stopData.dropOut) }),
    ...(rowState.loadType === 'dropLoad' && header.key === 'puDate' && { dropIn:  formatDate(rowState.stopData.dropIn) }),


    ...(rowState.stopData?.stopOrders && rowState.stopData?.stopOrders[0] && rowState.stopData.stopOrders[0]?.orderId && { orderId: rowState.stopData.stopOrders[0].orderId }),
    ...(rowState.stopData?.stopOrders && rowState.stopData?.stopOrders[0] && rowState.stopData.stopOrders[0]?.subOrderId && { subOrderId: rowState.stopData.stopOrders[0].subOrderId }),
  };

  axios
    .put(buildUrl('callcheck', 'updateloadstop'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        const payload = {
          page: 1,
          pageSize: 4,
          loadType: null,
          regionId: null,
          stateId: null,
          carrierId: null,
          mcNumber: null,
          dotNumber: null,
          searchText: null,
          pickAppointment: null,
          dropAppointment: null,
        };
        dispatch(errorAction(`callCheck/get${pageName}`, payload, true, response.data.message));
        console.error(response.data.message);
      }
      dispatch(reloadAfterUpdate(resource, pageName));
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

export const setOrderDateDetails = (resource, pageName, value, rowState, header) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS),
    data: {
      value,
      rowState,
      header,
    },
  });

  const date = new Date(value);
  const formattedDate = value ? moment(date)
    .seconds(0)
    .milliseconds(0)
    .format("YYYY-MM-DDTHH:mm:ss") : null;

  console.log(rowState)
  const payload = {
    loadId: rowState.loadId,
    loadStopType: rowState.loadType === 'pickLoad' ? 1 : 2,
    ...(rowState.orderData.orderId && { orderId: rowState.orderData.orderId }),
    ...(rowState.orderData.subOrderId && { subOrderId: rowState.orderData.subOrderId }),
    ...(header.key === 'puDate' && { puDate: formattedDate }),
  };

  axios
    .put(buildUrl('callcheck', 'updateloadstop'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        const payload = {
          page: 1,
          pageSize: 4,
          loadType: null,
          regionId: null,
          stateId: null,
          carrierId: null,
          mcNumber: null,
          dotNumber: null,
          searchText: null,
          pickAppointment: null,
          dropAppointment: null,
        };
        dispatch(errorAction(`callCheck/get${pageName}`, payload, true, response.data.message));
        console.error(response.data.message);
      }
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};


export const setOrderDeliverDateDetails = (resource, pageName, value, rowState, header) => dispatch => {
  dispatch({
    type: actionTypes.getActionType(resource, actionTypes.SET_CALL_CHECK_LOADS_ORDER_DELIVER_DATE_DETAILS),
    data: {
      value,
      rowState,
      header,
    },
  });

  const date = new Date(value);
  const formattedDate = moment(date)
    .seconds(0)
    .milliseconds(0)
    .format("YYYY-MM-DDTHH:mm:ss");

  const payload = {
    loadId: rowState.loadId,
    loadStopType: rowState.loadType === 'pickLoad' ? 1 : 2,
    puDate: rowState.orderData.puDate,
    deliverData: formattedDate,

    ...(rowState.orderData?.orderId && { orderId: rowState.orderData.orderId }),
    ...(rowState.orderData?.subOrderId && { orderId: rowState.orderData.subOrderId }),
  };

  axios
    .put(buildUrl('callcheck', 'updatedeliverdate'), payload, axiosConfig())
    .then(response => {
      if (response.data.hasError) {
        dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR), data: response.data.message });
        const payload = {
          page: 1,
          pageSize: 4,
          loadType: null,
          regionId: null,
          stateId: null,
          carrierId: null,
          mcNumber: null,
          dotNumber: null,
          searchText: null,
          pickAppointment: null,
          dropAppointment: null,
        };
        dispatch(errorAction(`callCheck/get${pageName}`, payload, true, response.data.message));
        console.error(response.data.message);
      }
    })
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.CALL_CHECK_LOADS_ERROR) });
    });
};

// EFS actions
export const getEFSList = (resource, loadId, withLoading) => dispatch => {
  const noLoading = withLoading !== 'withLoading';
  const data = {
    params: {
      loadId: loadId,
    },
    headers: axiosConfig().headers,
  };

  noLoading && dispatch({ type: actionTypes.getActionType(resource, actionTypes.EFS_LIST_LOADING) });
  axios
    .get(buildUrl(resource, 'getloadefs'), data, axiosConfig())
    .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_EFS_LIST), data: responce }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.EFS_LIST_ERROR) });
    });
};

export const getEmptyEFS = resource => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.EMPTY_EFS_LOADING) });
  axios
    .get(buildUrl(resource, '0'), axiosConfig())
    .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_EMPTY_EFS), data: responce }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.EMPTY_EFS_ERROR) });
    });
};

export const getEFS = (resource, efsId) => dispatch => {
  const data = {
    params: {
      id: efsId,
    },
    headers: axiosConfig().headers,
  };

  dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_EFS_LOADING) });
  axios
    .get(buildUrl(resource, 'getefs'), data, axiosConfig())
    .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_EFS), data: responce }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.GET_EFS_ERROR) });
    });
};

export const setEFS = (resource, newEFSData) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_EFS_LOADING) });
  axios
    .post(buildUrl(resource, 'createefs'), newEFSData, axiosConfig())
    .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_EFS), data: responce }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.SET_EFS_ERROR) });
    });
};

export const updateEFS = (resource, newEFSData) => dispatch => {
  dispatch({ type: actionTypes.getActionType(resource, actionTypes.UPDATE_EFS_LOADING) });
  axios
    .put(buildUrl(resource, 'updateefs'), newEFSData, axiosConfig())
    .then(responce => dispatch({ type: actionTypes.getActionType(resource, actionTypes.UPDATE_EFS), data: responce }))
    .catch(err => {
      console.error(err);
      console.log(err.response);
      dispatch({ type: actionTypes.getActionType(resource, actionTypes.UPDATE_EFS_ERROR) });
    });
};

// end EFS actions

export const reactOnItem = (resource, id, type) =>
    ({ type: actionTypes.getActionType(resource, actionTypes.REACT_ITEM), data: { id, type } });

export const createOrderLumper = (resource, id, outboundLumper, loadId) => dispatch => {
    const url = 'api/order/createorderlumperEF';
    const orderData = {
        id,
        outboundLumper,
    };
    axios.post(url, orderData,
        axiosConfig())
        .then(response => {
            if (response.data.hasError) {
                dispatch(errorAction(resource, true, response.data.message));
                console.error(response.data.message);
            }
            dispatch(getLoadDetails(resource, loadId));
        }).catch(err => {
            dispatch(errorAction(resource, true));
            console.error(err);
            console.log(err.response);
        });
    
};